export default "__VITE_ASSET__5ELudTll__"